/**
 * フォーム送信の二重送信を防止するクラス
 * CSSのpointer-eventsで物理的にクリックを無効化し、二重送信を防止
 */
export class FormSubmitPrevention {
  private forms: NodeListOf<HTMLFormElement>;
  private submittingForms: WeakSet<HTMLFormElement> = new WeakSet();

  constructor(formSelector: string = 'form') {
    this.forms = document.querySelectorAll(formSelector);
    this.init();
  }

  /**
   * 初期化処理
   */
  private init(): void {
    if (this.forms.length === 0) {
      console.warn('[FormSubmitPrevention] No forms found');
      return;
    }

    this.forms.forEach(form => {
      form.addEventListener('submit', (e) => this.handleSubmit(e));
    });

    console.log(`[FormSubmitPrevention] Initialized for ${this.forms.length} form(s)`);
  }

  /**
   * フォーム送信時の処理
   */
  private handleSubmit(e: Event): void {
    const form = e.target as HTMLFormElement;
    const submitButton = this.getClickedSubmitButton(form);

    // 戻るボタンまたは確認画面へボタンの場合は二重送信防止をスキップ
    if (submitButton && (submitButton.name === 'submitBack' || submitButton.name === 'submitConfirm')) {
      return;
    }

    // 既に送信中の場合は送信をキャンセル
    if (this.submittingForms.has(form)) {
      e.preventDefault();
      console.log('[FormSubmitPrevention] Prevented duplicate submission');
      return;
    }

    // 送信中フラグを立てる
    this.submittingForms.add(form);

    // すべての送信ボタンにis-submittingクラスを追加（CSSでpointer-events: noneが適用される）
    this.disableSubmitButtons(form);

    console.log('[FormSubmitPrevention] Form submission started');
  }

  /**
   * クリックされた送信ボタンを取得
   */
  private getClickedSubmitButton(form: HTMLFormElement): HTMLInputElement | HTMLButtonElement | null {
    // 最後にクリックされた送信ボタンを特定
    const submitButtons = form.querySelectorAll('input[type="submit"], button[type="submit"]');

    // activeElementを使用して現在フォーカスされているボタンを取得
    const activeElement = document.activeElement;
    if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'BUTTON')) {
      return activeElement as HTMLInputElement | HTMLButtonElement;
    }

    // フォールバック: 最初の送信ボタンを返す
    return submitButtons[0] as HTMLInputElement | HTMLButtonElement || null;
  }

  /**
   * フォーム内のすべての送信ボタンを無効化（CSSのみ、disabled属性は使用しない）
   */
  private disableSubmitButtons(form: HTMLFormElement): void {
    const submitButtons = form.querySelectorAll('input[type="submit"], button[type="submit"]');

    submitButtons.forEach(button => {
      button.classList.add('is-submitting');
    });
  }
}
